export const STICK_THRESHOLD_PX = 24;

export const isNearBottom = ({
  scrollTop,
  scrollHeight,
  clientHeight,
}: {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}) => scrollHeight - scrollTop - clientHeight <= STICK_THRESHOLD_PX;

export const RESTICK_WHILE_MOVING_DOWN_PX = STICK_THRESHOLD_PX * 4;

export const nextStickToBottom = (
  wasSticking: boolean,
  previousScrollTop: number,
  metrics: { scrollTop: number; scrollHeight: number; clientHeight: number }
) => {
  if (isNearBottom(metrics)) return true;
  if (metrics.scrollTop < previousScrollTop) return false;
  const distance =
    metrics.scrollHeight - metrics.scrollTop - metrics.clientHeight;
  if (
    metrics.scrollTop > previousScrollTop &&
    distance <= RESTICK_WHILE_MOVING_DOWN_PX
  ) {
    return true;
  }
  return wasSticking;
};

const SCROLL_UP_KEYS = new Set(['PageUp', 'ArrowUp', 'Home']);

export const isScrollUpIntent = (
  event:
    | { type: 'wheel'; deltaY: number }
    | { type: 'touchmove' }
    | { type: 'keydown'; key: string }
) => {
  switch (event.type) {
    case 'wheel':
      return event.deltaY < 0;
    case 'touchmove':
      return true;
    case 'keydown':
      return SCROLL_UP_KEYS.has(event.key);
    default:
      return false;
  }
};
